/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/app/store";
import Button from "../ui/Button";
import AuthPageWrapper from "./AuthPageWrapper";
import OTPInput from "../ui/OTPInput";
import axiosInstance from "../../apis/baseUrl";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../redux/app/hooks";
import { updateUnAuthorizedForgotPassword } from "../../redux/features/authSlice";

const ForgotPasswordOTP: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, unAuthorizedForgotPassword } = useSelector(
    (state: RootState) => state.auth
  );
  const dispatch = useAppDispatch();
  const [otpSent, setOtpSent] = useState(false); // Track if OTP has been sent
  const [countdown, setCountdown] = useState(0); // Countdown timer in seconds
  const [isResendDisabled, setIsResendDisabled] = useState(false); // Disable resend button during countdown

  if (isAuthenticated) {
    navigate("/dashboard");
  }

  const startCountdown = () => {
    setIsResendDisabled(true); // Disable the resend button
    setCountdown(60); // Set countdown to 60 seconds

    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          clearInterval(interval); // Stop the countdown when it reaches 0
          setIsResendDisabled(false); // Re-enable the resend button
          return 0;
        }
        return prev - 1;
      });
    }, 1000); // Update countdown every second
  };

  const handleResendOTP = async () => {
    try {
      const response: any = await axiosInstance.post(
        "v1/auth/send_reset_password",
        { email: unAuthorizedForgotPassword?.email }
      );

      if (response?.data) {
        toast.success(response?.data?.message);
        dispatch(
          updateUnAuthorizedForgotPassword({
            name: "hash",
            value: response?.data?.data,
          })
        );
        setOtpSent(true); // Mark OTP as sent
        startCountdown(); // Start the 60-second countdown
      } else {
        console.error("Failed to send OTP");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
    }
  };

  const handleOTPComplete = async (enteredOtp: string) => {
    dispatch(
      updateUnAuthorizedForgotPassword({ name: "otp", value: enteredOtp })
    );
    navigate("/reset-password");
  };

  return (
    <AuthPageWrapper
      title="Verify your email"
      sub_title="Enter the 6 digit code sent to your email address creativefantah@gmail.com to reset password "
    >
      <form className="space-y-4 w-full md:w-[450px]">
        <OTPInput length={6} onComplete={handleOTPComplete} />

        <p className="text-sm text-gray-500 mt-6 text-center w-[450px] flex gap-2">
          Didn't receive a code?{" "}
          <div
            className=" align-left text-primary cursor-pointer"
            onClick={!isResendDisabled ? handleResendOTP : undefined}
            style={{
              cursor: isResendDisabled ? "not-allowed" : "pointer",
              opacity: isResendDisabled ? 0.5 : 1,
            }}
          >
            {isResendDisabled
              ? `Resend OTP in ${countdown} seconds`
              : otpSent
              ? "Resend OTP"
              : "Resend OTP"}
          </div>
        </p>
        <Button label="Verify OTP" type="button" />
      </form>
    </AuthPageWrapper>
  );
};

export default ForgotPasswordOTP;
